export const zh_CN: Record<string, any> = {
  pluginName: '全局状态',
};
